import React from "react";

import "./GameLog.css";

import {
  current_gamelogs_leagues,
  findSportByLeague,
  getCurrentSeasonForLeagueFromRC,
} from "../../../../utils/utils";
import { API_CONSTANTS } from "../../../../utils/constantInformation";
import { sportPositionMapping } from "../../../../utils/sportsConfig";

function GameLog(props) {
  const player_actual_season_stats = props.player_actual_season_stats;
  const player_all_gamelogs = props.gamelogs;
  const [player_selected_season_gamelogs, setPlayerSelectedSeasonGamelogs] =
    React.useState([]);

  const [navSelectedTab, setNavSelectedTab] = React.useState(
    getCurrentSeasonForLeagueFromRC(props.league, props.rcConfig)
  );
  // Call changeActiveState when the component mounts and when navSelectedTab changes
  React.useEffect(() => {
    changeActiveState(navSelectedTab);
  }, [navSelectedTab]);
  React.useEffect(
    (async) => {
      document.title = "Player Gamelog";
      // let setStatsName;
      const sport = findSportByLeague(
        props.league,
        props.rcConfig,
        "GameLog useeffect"
      );
      const setStatsName = sportPositionMapping[sport][props.player_position];
      // if (props.player_position == "BAT") {
      //   setStatsName = batsman_stats;
      // } else if (props.player_position == "BOWL") {
      //   setStatsName = bowler_stats;
      // } else if (props.player_position == "AR") {
      //   setStatsName = all_rounder;
      // } else {
      //   setStatsName = wicket_keeper;
      // }

      const player_selected_season_gamelogs = player_all_gamelogs.filter(
        (el) => {
          return el.Season == navSelectedTab;
        }
      );

      const display_player_gamelogs = [];
      for (var i = 0; i < player_selected_season_gamelogs.length; i++) {
        let game_date = new Date(player_selected_season_gamelogs[i]["Date"]);
        game_date = game_date.getDate() + "/" + (game_date.getMonth() + 1);
        let temp_values = [
          {
            display_name: "Date",
            value: game_date,
          },
          {
            display_name: "Opp",
            value: player_selected_season_gamelogs[i]["Opponent"],
          },
        ];
        for (var j = 0; j < setStatsName.length; j++) {
          let stastsName = setStatsName[j].display_name;
          if (stastsName == "FP") {
            temp_values.push({
              display_name: "FP",
              value:
                player_selected_season_gamelogs[i][
                  "Dream11ActualFantasyPoints"
                ],
            });
          } else {
            temp_values.push({
              display_name: stastsName,
              value:
                player_selected_season_gamelogs[i][setStatsName[j].actual_name],
            });
          }
        }
        display_player_gamelogs.push(temp_values);
      }

      setPlayerSelectedSeasonGamelogs(display_player_gamelogs);
      console.log("Gamelos---", display_player_gamelogs, player_all_gamelogs);
    },
    [player_actual_season_stats, navSelectedTab]
  );
  // Define your seasons
  const currentSeason = getCurrentSeasonForLeagueFromRC(
    props.league,
    props.rcConfig
  );

  let seasons;

  try {
    let leagueConf;
  
    if (process.env.REACT_APP_ENV === "production") {
      leagueConf = JSON.parse(props.rcConfig.config.leagueConf._value);
    }
    else{
      leagueConf = JSON.parse(props.rcConfig.config.leagueConfTesting._value);
    }
    const selectedLeague = leagueConf.leagues.find(league => league.leagueName === props.league);
  
    const numHistoricSeasons = selectedLeague ? selectedLeague.historicGameLogs.numHistoricSeasons : null;
  
    if(numHistoricSeasons != null){
      seasons = []
      for(let i=0; i <= numHistoricSeasons; i++){
        seasons.push(currentSeason-i);
      }
    }
    else{
      seasons = [currentSeason, currentSeason - 1, currentSeason - 2];
    }
  }
  catch(err){
    seasons = [currentSeason, currentSeason - 1, currentSeason - 2];
  }

  // Define your function to change the active state
  const changeActiveState = (selectedSeason) => {
    console.log(`${props.gameInformationReducer.sports}`);
    console.log("selectedSeason", selectedSeason);
    seasons.forEach((season) => {
      console.log("season", season, `season${season}`);
      const element = document.getElementById(`season${season}`);
      console.log("element", element);
      if (element) {
        console.log("season", season, "selectedSeason", selectedSeason);
        if (parseInt(season, 10) === parseInt(selectedSeason, 10)) {
          element.classList.add("btn-dark");
        } else {
          element.classList.remove("btn-dark");
        }
      }
    });
  };
  // const changeActiveState = function(recentSeason, lastSeason, lastToLastSeason) {
  //   const seasons = ['2024', '2023', '2022', '2021'];
  //   seasons.forEach((season) => {
  //     const element = document.getElementById(`season${season}`);
  //     if (element) {
  //       if ((recentSeason && season === '2024') ||
  //           (lastSeason && season === '2023') ||
  //           (lastToLastSeason && (season === '2022' || season === '2021'))) {
  //         element.classList.add("btn-dark");
  //       } else {
  //         element.classList.remove("btn-dark");
  //       }
  //     }
  //   });
  // };
  // changeActiveState(true, false, false);
  // const changeActiveState = function(
  //   recentSeason,
  //   lastSeason,
  //   lastToLastSeason,
  // ) {
  //   if (recentSeason) {
  //     document.getElementById("recentSeason").classList.add("btn-dark");
  //     document.getElementById("lastSeason").classList.remove("btn-dark");
  //     document.getElementById("lastToLastSeason").classList.remove("btn-dark");
  //   } else if (lastSeason) {
  //     document.getElementById("recentSeason").classList.remove("btn-dark");
  //     document.getElementById("lastSeason").classList.add("btn-dark");
  //     document.getElementById("lastToLastSeason").classList.remove("btn-dark");
  //   } else if (lastToLastSeason) {
  //     document.getElementById("recentSeason").classList.remove("btn-dark");
  //     document.getElementById("lastSeason").classList.remove("btn-dark");
  //     document.getElementById("lastToLastSeason").classList.add("btn-dark");
  //   }
  // };
  return (
    <div className="bg-dark game-log-null">
      {/* Gamlogs navbar Starts Here */}
      <div className="d-flex justify-content-center pt-2 pb-2 bg-dark">
        {current_gamelogs_leagues[
          props.gameInformationReducer.platform
        ].includes(props.gameInformationReducer.sports) ? (
          <ul className="nav nav-pills bg-secondary rounded p-1">
            <li className="nav-item">
              <button
                className="btn nav-link btn-dark text-white"
                id="recentSeason"
                onClick={() => {
                  setNavSelectedTab(currentSeason);
                  // changeActiveState(true, false, false);
                }}
              >
                2022
              </button>
            </li>
          </ul>
        ) : (
          <ul className="nav nav-pills bg-secondary rounded p-1">
            {seasons.map((year, index) => (
              <li className="nav-item" key={index}>
                <button
                  className="btn nav-link btn-dark text-white"
                  id={`season${year}`}
                  onClick={() => {
                    setNavSelectedTab(parseInt(year, 10));
                    // changeActiveState(index === 0, index === 1, index === 2);
                  }}
                >
                  {year}
                </button>
              </li>
            ))}
            {/* {leagues2023.includes(props.gameInformationReducer.sports)
              ? ["2023", "2022", "2021"].map((year, index) => (
                  <li className="nav-item" key={index}>
                    <button
                      className="btn nav-link btn-dark text-white"
                      id={`season${year}`}
                      onClick={() => {
                        setNavSelectedTab(parseInt(year, 10));
                        // changeActiveState(index === 0, index === 1, index === 2);
                      }}
                    >
                      {year}
                    </button>
                  </li>
                ))
              : ["2024", "2023", "2022"].map((year, index) => (
                  <li className="nav-item" key={index}>
                    <button
                      className="btn nav-link btn-dark text-white"
                      id={`season${year}`}
                      onClick={() => {
                        setNavSelectedTab(parseInt(year, 10));
                        // changeActiveState(index === 0, index === 1, index === 2);
                      }}
                    >
                      {year}
                    </button>
                  </li>
                ))} */}
          </ul>
          // <ul className="nav nav-pills bg-secondary rounded p-1">
          //   <li className="nav-item">
          //     <button
          //       className="btn nav-link btn-dark text-white"
          //       id="recentSeason"
          //       onClick={() => {
          //         setNavSelectedTab(2023);
          //         changeActiveState(true, false, false);
          //       }}
          //     >
          //       2023
          //     </button>
          //   </li>
          //   <li className="nav-item">
          //     <button
          //       className="btn nav-link text-white"
          //       id="lastSeason"
          //       onClick={() => {
          //         setNavSelectedTab(2022);
          //         changeActiveState(false, true, false);
          //       }}
          //     >
          //       2022
          //     </button>
          //   </li>
          //   <li className="nav-item ">
          //     <button
          //       className="btn nav-link  text-white"
          //       id="lastToLastSeason"
          //       onClick={() => {
          //         setNavSelectedTab(2021);
          //         changeActiveState(false, false, true);
          //       }}
          //     >
          //       2021
          //     </button>
          //   </li>
          // </ul>
        )}
      </div>
      {/* Navbar ends Here */}
      {player_selected_season_gamelogs.length ? (
        <div className="table-responsive">
          <table className="table table-dark table-hover table-striped">
            <thead>
              <tr>
                {player_selected_season_gamelogs[0].map(
                  (each_game_stats, index2) => (
                    <td key={index2}>
                      <span className="text-center">
                        <b>{each_game_stats.display_name}</b>
                      </span>
                    </td>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {player_selected_season_gamelogs.map((each_game_log, index1) => (
                <tr key={index1}>
                  {each_game_log.map((each_game_stats, index2) => (
                    <td key={index2}>
                      {each_game_stats.value !=
                      API_CONSTANTS.NUMERIC_CONSTANT ? (
                        <span className="text-center">
                          {each_game_stats.value}
                        </span>
                      ) : (
                        "--"
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="d-flex justify-content-center bg-dark ">
          <h3 className="text-secondary pt-5">No Data Available</h3>
        </div>
      )}
    </div>
  );
}

export default GameLog;
